// import MuiModel from "../../../components/Mui/model/MuiModel";

import { useEffect, useState } from "react";
import MuiModelTab from "../Mui/model/MuiModelTab";
import { useModal } from "../../hooks/useModal";
import { useData } from "../../context/GetDataContext";
import moment from "moment";
import { Button, Checkbox, FormControlLabel } from "@mui/material";
import { LoadStatus } from "./LoadStatus";
import { LoadStatusTracker } from "./LoadStatusTracker";
import LoadSideBarSkeleton from "./LoadSideBarSkeleton";
import { isEmpty } from "lodash";
import { useQuery } from "@apollo/client";
import { LOAD_QUERY } from "./queries";
import Stop from "./components/stop";
import MuiModel from "../Mui/model/MuiModel";
import { useSearchParams } from "react-router";
import { decryptObject } from "../../utils/crypt";
import LoadDispatch from "./components/loadDispatch";
interface props {
  source: any;
  getformData: any;
}

const LoadSideBarform = ({ source, getformData }: props) => {
  const { isOpen, openModal, closeModal } = useModal();
  const [form, setForm] = useState("");
  const [formTitle, setFormTitle] = useState("");
  const [popFormId, setPopFormId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [isSection, setIsSection] = useState(false);
  const [formAction, setFormAction] = useState("");

  const {
    loading,
    error,
    data: apolloData,
  } = useQuery(LOAD_QUERY, {
    variables: { id: 1032 },
    fetchPolicy: "cache-first",
  });

  const { data } = useData();

  // useEffect(() => {
  //   if (data) {
  //     closeModal();
  //   }
  // }, [data]);

  // console.log(apolloData);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  if (!data?.id) {
    return <LoadSideBarSkeleton />;
  }

  const loadHasDispatch = !isEmpty(data?.dispatch);

  return (
    <>
      <div className="border mt-2.5">
        <div className="bg-white rounded-lg p-3">
          <h1 className="text-lg font-bold mb-4">Shipper/Consignee</h1>
          <h2 className="text-md font-semibold">Stops Info</h2>

          <h3 className="text-md font-semibold mt-4 bg-gray-200 p-2">
            Dispatch Info
          </h3>
          {/* <div className=" mb-4">
          <ButtonGroup variant="outlined" aria-label="Basic button group">
            <Button> Dispatch Load</Button>
            <Button> Broker Load</Button>
            <Button> Assign To LTL Trip</Button>
            <Button> Assign To Local Trip</Button>
            <Button> Create</Button>
          </ButtonGroup>
        </div> */}
          {/* data?.dispatch */}
          <LoadDispatch source={source} />
          <div className="flex space-x-2 mb-4 text-xs">
            <Stop />
          </div>

          {loadHasDispatch && (
            <>
              <div className="flex gap-3 text-xs mb-3">
                <div>
                  <LoadStatus data={data} />
                </div>
                <div>
                  <button className="bg-blue-500 text-white px-2 py-2 rounded text-xs">
                    LTL
                  </button>
                </div>
                <div>
                  <button className="bg-red-500 text-white px-2 py-2 rounded text-xs">
                    Hazmat?
                  </button>
                </div>
                <div>
                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="Primary Unit?"
                    sx={{
                      marginRight: "0",
                      ".MuiTypography-root": {
                        fontSize: "0.9rem",
                      },
                    }}
                  />
                </div>
                <div>
                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="Local Trip?"
                    sx={{
                      marginRight: "0",
                      ".MuiTypography-root": {
                        fontSize: "0.9rem",
                      },
                    }}
                  />
                </div>
              </div>
              <LoadStatusTracker data={data} />
            </>
          )}

          <div className="border mb-3">
            <h2 className="font-bold bg-gray-100 text-sm p-2">
              PICKUP - STOP#1
            </h2>

            <div className="flex gap-4 p-2">
              <div className="flex-1">
                <div className="mb-3">
                  <h3 className="font-bold text-xs">Date</h3>
                  <p className="text-xs text-gray-600">
                    {moment(data?.pick_up_date).format("MM-DD-YYYY")}{" "}
                    <strong>Time -</strong>
                    {data?.pick_up_starttime} - {data?.pick_up_endtime}
                  </p>
                </div>
                <div className="mb-3">
                  <h3 className="font-bold text-xs">{data?.shipper?.name}</h3>
                  <p className="font-light text-xs">
                    {data?.shipper?.address}, {data?.shipper?.city},{" "}
                    {data?.shipper?.state}, {data?.shipper?.zipCode}
                  </p>
                </div>
                <div className="mb-3">
                  <p className="font-bold text-xs text-yellow-500">
                    Location Notes:
                  </p>
                  <p className="font-light text-xs lowercase">
                    {data?.shipper?.notes}
                  </p>
                </div>

                <div className="mb-3">
                  <h3 className="font-bold text-xs">Instructions:</h3>
                  <p className="font-light text-xs">
                    {data?.pick_up_instructions}
                  </p>
                </div>
                <div className="mb-3">
                  <h3 className=" text-xs mb-2">
                    <strong>Stop Pickup:</strong> {data?.pick_up_stop_pickup}
                  </h3>
                  <p className="font-bold text-xs bg-orange-100 px-2 py-1 rounded">
                    0 Empty Miles
                  </p>
                </div>

                <div className="flex space-x-2 mt-4 text-xs">
                  <span className="bg-gray-200 px-1 py-1 rounded">In:</span>
                  <span className="bg-gray-200 px-1 py-1 rounded">Out:</span>
                  <span className="bg-gray-200 px-1 py-1 rounded">
                    Detention:
                  </span>
                  <button className="bg-yellow-400 text-white px-2 py-1 rounded">
                    Add Contacts
                  </button>
                </div>
              </div>
              <div className="flex-1 ">
                <div className="mb-5 text-xs">
                  <ul>
                    <li>
                      <strong>Total Qty:</strong>
                      {data?.pick_up_total_quantity}
                    </li>
                    <li>
                      <strong>Total Weight:</strong>
                      {data?.pick_up_total_weight}
                    </li>
                    <li>
                      <strong>Commodity:</strong>
                      {data?.pick_up_commodity}
                    </li>
                    <li>
                      <strong>Route Name:</strong>
                      {data?.pick_up_route_name}
                    </li>
                  </ul>
                </div>
                <div className="mb-3 text-xs">
                  <ul>
                    <li>
                      <strong>Cutomer Load/Ref/Conf # :</strong>
                      {data?.pick_up_customer_load_ref}
                    </li>
                    <li>
                      <strong>Shipment BOL # :</strong>
                      {data?.pick_up_shipment_bol}
                    </li>
                    <li>
                      <strong>PO Number # :</strong>
                      {data?.pick_up_po_number}
                    </li>
                    <li>
                      <strong>Pickup # :</strong>
                      {data?.pickup}
                    </li>
                  </ul>
                </div>
                <div className="flex space-x-2 mt-4 text-xs">
                  <button className="bg-green-500 text-white px-2 py-1 rounded">
                    Split
                  </button>
                  <button
                    className="bg-blue-500 text-white px-2 py-1 rounded"
                    onClick={() => {
                      openModal();
                      setFormAction("update");
                      setSectionId("pickup");
                      setPopFormId("load");
                      setIsSection(true);
                    }}
                  >
                    Edit
                  </button>
                  <button className="bg-blue-500 text-white px-2 py-1 rounded">
                    Add Commodity
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="border">
            <h2 className="font-bold bg-gray-100 text-sm p-2">
              DELIVERY - STOP#2
            </h2>

            <div className="flex gap-4 p-2">
              <div className="flex-1">
                <div className="mb-3">
                  <h3 className="font-bold text-xs">Date</h3>
                  <p className="text-xs text-gray-600">
                    {moment(data?.delivery_date).format("MM-DD-YYYY")}{" "}
                    <strong>Time -</strong>
                    {data?.delivery_start_time} - {data?.delivery_end_time}
                  </p>
                </div>
                <div className="mb-3">
                  <h3 className="font-bold text-xs">{data?.consignee?.name}</h3>
                  <p className="font-light text-xs">
                    {data?.consignee?.address}, {data?.consignee?.city},{" "}
                    {data?.consignee?.state}, {data?.consignee?.zipCode}
                  </p>
                </div>
                <div className="mb-3">
                  <p className="font-bold text-xs text-yellow-500">
                    Location Notes:
                  </p>
                  <p className="font-light text-xs lowercase">
                    {data?.consignee?.notes}
                  </p>
                </div>

                <div className="mb-3">
                  <h3 className="font-bold text-xs">Instructions:</h3>
                  <p className="font-light text-xs">
                    {data?.delivery_instructions}
                  </p>
                </div>
                <div className="mb-3">
                  <h3 className=" text-xs mb-2">
                    <strong>Stop Delivery:</strong>{" "}
                    {data?.delivery_stop_delivery}
                  </h3>
                  <p className="font-bold text-xs bg-orange-100 px-2 py-1 rounded">
                    0 Empty Miles
                  </p>
                </div>

                <div className="flex space-x-2 mt-4 text-xs">
                  <span className="bg-gray-200 px-1 py-1 rounded">In:</span>
                  <span className="bg-gray-200 px-1 py-1 rounded">Out:</span>
                  <span className="bg-gray-200 px-1 py-1 rounded">
                    Detention:
                  </span>
                  <button className="bg-yellow-400 text-white px-2 py-1 rounded">
                    Add Contacts
                  </button>
                </div>
              </div>
              <div className="flex-1 ">
                <div className="mb-5 text-xs">
                  <ul>
                    <li>
                      <strong>Total Qty:</strong>
                      {data?.delivery_total_quantity}
                    </li>
                    <li>
                      <strong>Total Weight:</strong>
                      {data?.delivery_total_weight}
                    </li>
                    <li>
                      <strong>Commodity:</strong>
                      {data?.delivery_commodity}
                    </li>
                    {/* <li>
                      <strong>Route Name:</strong>
                      {data?.pick_up_route_name}
                    </li> */}
                  </ul>
                </div>
                <div className="mb-3 text-xs">
                  <ul>
                    <li>
                      <strong>Cutomer Load/Ref/Conf # :</strong>
                      {data?.delivery_customer_load_ref}
                    </li>
                    <li>
                      <strong>Shipment BOL # :</strong>
                      {data?.delivery_shipment_bol}
                    </li>
                    <li>
                      <strong>PO Number # :</strong>
                      {data?.delivery_po_number}
                    </li>
                    <li>
                      <strong>Pickup # :</strong>
                      {data?.delivery}
                    </li>
                  </ul>
                </div>
                <div className="flex space-x-2 mt-4 text-xs">
                  <button className="bg-green-500 text-white px-2 py-1 rounded">
                    Split
                  </button>
                  <button
                    className="bg-blue-500 text-white px-2 py-1 rounded"
                    onClick={() => {
                      openModal();
                      setFormAction("update");
                      setSectionId("delivery");
                      setPopFormId("load");
                      setIsSection(true);
                    }}
                  >
                    Edit
                  </button>
                  <button className="bg-blue-500 text-white px-2 py-1 rounded">
                    Add Commodity
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <MuiModel
                    isOpen={isOpen}
                    onClose={closeModal}
                    formId={popFormId}
                    isFormSections={{ is: isSection, sectionsids: sectionId }}
                  /> */}
      {isOpen && (
        <>
          {["pickup", "delivery"].includes(sectionId) ? (
            <MuiModel
              isOpen={isOpen}
              onClose={closeModal}
              formId={popFormId}
              source={source}
              isFormSections={{
                is: isSection,
                sectionsids: sectionId,
                formAction: formAction,
              }}
            />
          ) : (
            <MuiModelTab
              isOpen={isOpen}
              onClose={closeModal}
              formId={popFormId}
              source={source}
              title={formTitle}
            />
          )}
        </>
      )}
    </>
  );
};

export default LoadSideBarform;
